/* =========================================================
   NOMI — theme behaviour
   Vanilla, no dependencies. Progressive enhancement only:
   every interaction here has a working no-JS fallback.
   ========================================================= */
(function () {
  'use strict';

  var cfg = window.NOMI || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Scrim ---------- */
  var scrim = $('[data-scrim]');
  var openPanel = null;

  function showScrim() {
    if (!scrim) return;
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-open'); });
  }

  function hideScrim() {
    if (!scrim) return;
    scrim.classList.remove('is-open');
    setTimeout(function () { scrim.hidden = true; }, 420);
  }

  function openOverlay(el) {
    if (!el) return;
    closeOverlay();
    openPanel = el;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    showScrim();
    var focusable = el.querySelector('button, a, input, textarea, select');
    if (focusable) focusable.focus();
  }

  function closeOverlay() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    openPanel.setAttribute('aria-hidden', 'true');
    openPanel = null;
    document.body.style.overflow = '';
    hideScrim();
  }

  if (scrim) scrim.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });

  /* ---------- Menu drawer ---------- */
  var menuDrawer = $('[data-menu-drawer]');

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      e.preventDefault();
      openOverlay(menuDrawer);
    }
    if (e.target.closest('[data-menu-close]')) {
      e.preventDefault();
      closeOverlay();
    }
  });

  /* ---------- Cart ---------- */
  var cartDrawer = $('[data-cart-drawer]');

  function formatMoney(cents) {
    // Shopify money_format is HTML with a placeholder; fall back to a plain rupee string.
    var amount = (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    var fmt = cfg.moneyFormat || '₹{{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /**
   * The drawer's markup belongs to snippets/cart-drawer-contents.liquid, which
   * is the only place that knows about the gift box add-on, the note field and
   * the empty state. Rebuilding that markup here meant the add-on disappeared
   * the moment anything touched the bag - including the add-to-bag that opens
   * the drawer in the first place, so most customers never saw it. Re-fetch the
   * rendered drawer instead of rebuilding it, and there is only one copy.
   *
   * Every handler below is delegated from document, so swapping the body's HTML
   * does not detach anything.
   */
  function refreshCartDrawer() {
    if (!cartDrawer) return Promise.resolve();
    return fetch(cfg.routes.cart, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-body]');
        var body = $('[data-cart-body]', cartDrawer);
        if (fresh && body) body.innerHTML = fresh.innerHTML;

        var count = doc.querySelector('[data-cart-count]');
        setCartCount(count ? parseInt(count.textContent, 10) || 0 : 0);
      });
  }

  function changeLine(line, quantity) {
    return fetch(cfg.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        return refreshCartDrawer().then(function () { return cart; });
      });
  }

  /* Open the drawer instead of navigating to /cart */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn && cfg.cartType === 'drawer' && cartDrawer) {
      e.preventDefault();
      openOverlay(cartDrawer);
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeOverlay();
    }

    var removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      e.preventDefault();
      changeLine(parseInt(removeBtn.dataset.line, 10), 0);
    }
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (!up && !down) return;

    var wrap = (up || down).closest('.qty');
    var input = $('[data-qty-input]', wrap);
    if (!input) return;

    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + (up ? 1 : -1);
    if (next < min) next = min;
    input.value = next;

    if (input.dataset.line) {
      changeLine(parseInt(input.dataset.line, 10), next);
    } else {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input && input.dataset.line) {
      changeLine(parseInt(input.dataset.line, 10), parseInt(input.value, 10) || 0);
    }
  });

  /* ---------- Add to cart ---------- */
  $$('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      // Buy it now posts normally so Shopify can honour return_to=/checkout.
      var submitter = e.submitter || form.querySelector('[data-buy-now]:focus');
      if (submitter && submitter.hasAttribute('data-buy-now')) return;
      if (cfg.cartType !== 'drawer' || !cartDrawer) return; // let the browser post normally
      e.preventDefault();

      var button = $('[data-add-button]', form);
      var status = $('[data-form-status]', form);
      var label = button ? button.textContent : '';

      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = '…';
      }

      fetch(cfg.routes.cart_add, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          if (status) status.textContent = '';
          return refreshCartDrawer();
        })
        .then(function () {
          openOverlay(cartDrawer);
        })
        .catch(function (err) {
          if (status) status.textContent = err.message;
        })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            button.textContent = label;
          }
        });
    });
  });

  /* ---------- Variant selection ---------- */
  $$('[data-variant-json]').forEach(function (node) {
    var variants;
    try { variants = JSON.parse(node.textContent); } catch (err) { return; }

    var form = node.closest('form');
    if (!form) return;

    var selects = $$('[data-option-index]', form);
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = $('.pdp__price');
    var button = $('[data-add-button]', form);

    function update() {
      var chosen = selects.map(function (s) { return s.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });

      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = '<span class="price">' + formatMoney(match.price) + '</span>';
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? cfg.strings.addToCart : cfg.strings.soldOut;
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
  });

  /* ---------- Collection sort ---------- */
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Product recommendations (async) ---------- */
  var recs = $('[data-recommendations]');
  if (recs && recs.dataset.url) {
    fetch(recs.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.section');
        if (section) recs.replaceWith(section);
        observeReveals();
      })
      .catch(function () { /* recommendations are optional */ });
  }

  /* ---------- Hero carousel ---------- */
  /* Cross-fade only — no sliding, no layout shift. Every slide is already in
     the markup, so with JS off the first one simply stays put. */
  function initCarousel(root) {
    if (root.dataset.carouselReady) return;
    var slides = $$('[data-carousel-slide]', root);
    var dots = $$('[data-carousel-dot]', root);
    if (slides.length < 2) return;
    root.dataset.carouselReady = 'true';

    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    var delay = parseInt(root.dataset.carouselInterval, 10) || 6000;
    var index = 0;
    var timer = null;

    function go(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function play() {
      stop();
      if (still.matches || document.hidden) return;
      timer = setInterval(function () { go(index + 1); }, delay);
    }

    root.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-carousel-dot]');
      if (!dot) return;
      go(parseInt(dot.dataset.carouselDot, 10) || 0);
      play();
    });

    root.addEventListener('keydown', function (e) {
      if (!e.target.closest('[data-carousel-dot]')) return;
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      go(index + (e.key === 'ArrowRight' ? 1 : -1));
      play();
      if (dots[index]) dots[index].focus();
    });

    /* Hovering or tabbing into the hero means someone is looking at this
       slide, so hold it until they leave. */
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', play);
    if (still.addEventListener) still.addEventListener('change', play);

    play();
  }

  $$('[data-carousel]').forEach(initCarousel);

  /* The theme editor swaps a section's markup out from under us, so anything
     it re-renders has to be wired up again. */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-carousel]', e.target).forEach(initCarousel);
    if (e.target.matches && e.target.matches('[data-carousel]')) initCarousel(e.target);
  });

  /* ---------- Reveal on scroll ---------- */
  var observer;

  function observeReveals() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px' }
      );
    }
    $$('.reveal:not(.is-in)').forEach(function (el) { observer.observe(el); });
  }

  observeReveals();
})();
